/* eslint-disable no-unused-vars */
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  min-height: 100vh;
`;

export const LoaderBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 99999;
`;

export const Title = styled.h1`
  color: ${Palette.PrimaryGray._900};
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 8px;
  margin-top: 24px;
`;

export const Paragraph = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  line-height: 20px;
`;

export const WelcomeBox = styled.div`
  width: 600px;
  height: auto;
  margin: auto;
  background: ${Palette.White._000};
  padding: 32px 48px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0px 1px 3px 0px rgba(30, 50, 70, 0.1), 0px 1px 2px 0px rgba(30, 50, 70, 0.06);
`;
